import React from 'react';

var GridViewActivateButton = React.createClass({
  getInitialState: function(){
    return { 
      isClicked : false
    };
  },
  handleClick: function(){
    this.setState ({isClicked : true})
    // if (this.props.value.user !== localStorage.getItem ('currentAccountSlug')) {
      var fullyQualifiedName =  this.props.value["name"];
      this.props.makeActive(fullyQualifiedName);
    // } else {
      // this.props.makeActive(this.props.value["slug"]);
    // }
  },
  render: function(){
    var classes = "animate__btn";
    if (this.state.isClicked) {
      classes += "  clicked"
    }
    return(
        <div className="theme-grid__buttons clearfix">
          <a href = "javascript:void(0)" className= {classes} onClick = {this.handleClick}>
            <span className="btn_1"><i className="fa fa-spinner fa-spin"></i> Waiting</span>
            <span className="btn_2">
              <strong className="icon">
                <i className="fa fa-arrow-circle-up"></i>
                <i className="fa  fa-check-circle"></i>
              </strong> Activate
            </span>
            <span className="btn_3"><i className="fa  fa-check-circle"></i> Active</span>
          </a>
        </div>
    );
  }
});

export {GridViewActivateButton}


/** WEBPACK FOOTER **
 ** ./html/components/GridViewActivateButton.jsx
 **/